__turbopack_context__.v({
  "fadeInContent": "styles-module-scss-module__vrBY2q__fadeInContent",
  "features": "styles-module-scss-module__vrBY2q__features",
  "item": "styles-module-scss-module__vrBY2q__item",
  "marquee": "styles-module-scss-module__vrBY2q__marquee",
});
